import { useScroll, useTransform, useSpring } from 'framer-motion';

export function useScrollAnimation() {
    const { scrollY } = useScroll();

    // Parallax suave para o background do hero
    const heroBackgroundY = useTransform(scrollY, [0, 1000], [0, 300]);

    // Parallax mais rápido para elementos flutuantes (grãos de café)
    const floatingElementsY = useTransform(scrollY, [0, 1000], [0, -150]);

    // Opacidade do header (transparente -> blur)
    const headerOpacity = useTransform(scrollY, [0, 100], [0, 1]);
    const headerBackground = useTransform(
        scrollY,
        [0, 100],
        ['rgba(0, 0, 0, 0)', 'rgba(var(--background-rgb), 0.8)']
    );

    // Smooth spring para animações de entrada
    const smoothY = useSpring(scrollY, {
        stiffness: 100,
        damping: 30,
        restDelta: 0.001
    });

    return {
        scrollY,
        smoothY,
        parallax: {
            background: heroBackgroundY,
            floating: floatingElementsY,
        },
        header: {
            opacity: headerOpacity,
            background: headerBackground,
        }
    };
}

// Utilitário para animações de entrada (Fade In Up)
export const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: [0.22, 1, 0.36, 1] // Curva ease-out "Apple-like"
        }
    }
};

// Utilitário para stagger (efeito cascata)
export const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1,
            delayChildren: 0.2
        }
    }
};
